// Copyright (c) 2016 Deere & Company

import './parts-panel.scss';
import React, {PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../../../../shared/services/alert-bar';
import {
    getVsrMessageForClaimItem,
    hasVsrErrorForClaimItem
} from '../../services/claim-shared-helper';
import {
    limitMaxValue,
    trimToLength
} from '../../../../shared/services/fix-data';
import ClaimPart from '@deere/cps-it.warranty-model-factory/lib/claim-item-part';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import FileCsvUpload from '../../../../shared/components/file-csv-upload/';
import {FormattedMessage} from 'react-intl';
import NonEditablePartsPanel from './non-editable-parts-panel';
import PartsPanelRowBody from './parts-panel-row-body';
import PartsPanelRowHeader from './parts-panel-row-header';
import {buildNumber} from '../../../../shared/services/build-number';
import {getColumnSeparator} from '../../../../shared/services/get-column-separator';
import {getStore} from '../../../../store-factory';

function handleDelete(index) {

    this.actions.deletePart(index);

}

function handleBlur(index, partNumber) {

    if (partNumber) {

        this.actions.readPartDetails(partNumber, index);

    }

}

function handlePartNumberChange(index, partNumber) {

    this.actions.changePartProperty(index, partNumber, 'partNumber');

}

function handleSerialNumberChange(index, partSerialNumber) {

    this.actions.changePartProperty(index, partSerialNumber, 'partSerialNumber');

}

function handleInvoiceNumberChange(index, invoiceNumber) {

    this.actions.changePartProperty(index, invoiceNumber, 'invoiceNumber');

}

function handleQuantityChange(index, quantity) {

    const value = quantity ?
        parseFloat(quantity) :
        null;

    this.actions.changePartProperty(index, value, 'quantity');

}

function handleUnitChange(index, unit, unitCollection) {

    this.actions.changePartsUnit(index, unit, unitCollection);

}

function handleBulkAddParts(parts) {

    /* eslint-disable max-depth */

    // first check that the data is in the proper format

    if ('QTY' in parts[0] && 'PART' in parts[0]) {

    // loop over each row and add a part for each one

        const initialPartsLength = this.parts.length;

        let i;

        for (i = 0; i < parts.length; i += 1) {

            const index = initialPartsLength + i;
            const quantity = limitMaxValue(parts[i].QTY, 99999);
            const partNumber = trimToLength(parts[i].PART, 40);
            const partSerialNumber = trimToLength(parts[i].SERIAL_NUMBER, 18);

            if (partNumber) {

                this.actions.addPart();
                this.actions.changePartProperty(index, quantity, 'quantity');
                this.actions.changePartProperty(index, partNumber, 'partNumber');
                this.actions.changePartProperty(index, partSerialNumber, 'partSerialNumber');
                this.actions.readPartDetails(partNumber, index);

            }

        }

    } else {

        errorAlertBar(createErrorObject('FILE_UPLOAD_UNABLE_TO_READ', false));

    }

    /* eslint-enable max-depth */

}

const getEditable = props =>
    props.parts.map((part, index) =>
        <PartsPanelRowBody
            highlightClass={hasVsrErrorForClaimItem(props.errors, 'PARTS', part.lineNumber)}
            isEditable={props.isEditable}
            key={index}
            numberOfParts={props.parts.length}
            onDelete={handleDelete.bind(props, index)}
            onInvoiceNumberChange={handleInvoiceNumberChange.bind(props, index)}
            onPartNumberBlur={handleBlur.bind(props, index)}
            onPartNumberChange={handlePartNumberChange.bind(props, index)}
            onQuantityChange={handleQuantityChange.bind(props, index)}
            onSerialNumberChange={handleSerialNumberChange.bind(props, index)}
            onUnitChange={handleUnitChange.bind(props, index)}
            part={part}
            partDetails={props.partsGroupedByPartNumber[part.partNumber]}
            showPartInvoiceNumber={props.showPartInvoiceNumber}
            vsrMessage={getVsrMessageForClaimItem(props.errors, 'PARTS', part.lineNumber)}
        />
    );

const getNonEditable = props =>
    props.parts.map((part, index) =>
        <NonEditablePartsPanel
            claimType={props.typeClaim}
            key={index}
            part={part}
            showPartInvoiceNumber={props.showPartInvoiceNumber}
        />
    );

const PartsPanel = props =>
    <section className='parts-panel'>
        <div className='parts-panel-header-wrapper'>
            <h3 className='parts-panel-title'>
                <FormattedMessage
                    id='PARTS_WITH_COUNT'
                    values={{
                        count: buildNumber(props.parts.length)
                    }}
                />
            </h3>
        </div>
        {props.isEditable && <PartsPanelRowHeader showPartInvoiceNumber={props.showPartInvoiceNumber}/>}
        <section className='part-list'>
            {props.isEditable ?
                getEditable(props) :
                getNonEditable(props)
            }
        </section>
        {props.isEditable &&
            <div>
                <button
                    className='add-part-icon-button'
                    onClick={props.actions.addPart}
                />
                <FileCsvUpload
                    handleFileAdded={handleBulkAddParts.bind(props)}
                />
                <div className='csv-message'>
                    <a
                        download={true}
                        href={getColumnSeparator(getStore().getState().user.details.settings.general.csvSeparator.key) === ',' ? './csv_templates/parts.csv' : './csv_templates/parts_sc.csv'}
                    >
                        <FormattedMessage id='PARTS_TEMPLATE'/>
                    </a>
                </div>
            </div>
        }
    </section>;

PartsPanel.displayName = 'PartsPanel';
PartsPanel.propTypes = {
    actions: PropTypes.object.isRequired,
    claimType: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    parts: PropTypes.arrayOf(PropTypes.instanceOf(ClaimPart)).isRequired,
    partsGroupedByPartNumber: PropTypes.object.isRequired,
    showPartInvoiceNumber: PropTypes.bool.isRequired
};

export default PartsPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/parts-panel/index.js